import { Quote } from "lucide-react";

export const TestimonialsSection = ({ testimonials }) => {
  return (
    <section className="py-20 relative overflow-hidden" data-testid="testimonials-section">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://images.unsplash.com/photo-1511632765486-a01980e01a18?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHw0fHxjaHVyY2glMjBjb21tdW5pdHl8ZW58MHx8fHwxNzYzNDU3MzQzfDA&ixlib=rb-4.1.0&q=85"
          alt="Community"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-blue-900/90"></div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center mb-16">
          <h2
            className="text-4xl sm:text-5xl font-bold text-white mb-4"
            style={{ fontFamily: "'Playfair Display', serif" }}
            data-testid="testimonials-title"
          >
            Lives Transformed
          </h2>
          <div className="w-24 h-1 bg-amber-500 mx-auto mb-6"></div>
          <p
            className="text-base sm:text-lg text-blue-100 max-w-2xl mx-auto"
            style={{ fontFamily: "'Crimson Text', serif" }}
          >
            Hear from those whose lives have been touched by God's grace through our ministry
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {testimonials.map((testimonial, index) => (
            <div
              key={testimonial.id}
              className="bg-white/95 backdrop-blur-sm rounded-xl p-8 hover:bg-white transition-colors"
              data-testid={`testimonial-card-${index}`}
            >
              <Quote className="text-amber-600 mb-4" size={40} />
              <p
                className="text-gray-700 mb-6 leading-relaxed text-base"
                style={{ fontFamily: "'Crimson Text', serif" }}
                data-testid={`testimonial-content-${index}`}
              >
                {testimonial.content}
              </p>
              <div className="flex items-center gap-3">
                <img
                  src={testimonial.avatar}
                  alt={testimonial.name}
                  className="w-12 h-12 rounded-full object-cover border-2 border-amber-500"
                />
                <div>
                  <h4
                    className="font-bold text-gray-900"
                    style={{ fontFamily: "'Playfair Display', serif" }}
                    data-testid={`testimonial-name-${index}`}
                  >
                    {testimonial.name}
                  </h4>
                  <p className="text-sm text-gray-600" data-testid={`testimonial-role-${index}`}>{testimonial.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};